// here are the form controls of the forms

export const countryCodeOptions = [
  { id: 'US +1', label: '+1 (United States)', phoneLength: 10 },
  { id: 'BS +1-242', label: '+1-242 (Bahamas)', phoneLength: 7 },
  { id: 'BB +1-246', label: '+1-246 (Barbados)', phoneLength: 7 },
  { id: 'AI +1-264', label: '+1-264 (Anguilla)', phoneLength: 7 },
  { id: 'AG +1-268', label: '+1-268 (Antigua and Barbuda)', phoneLength: 7 },
  { id: 'BM +1-441', label: '+1-441 (Bermuda)', phoneLength: 7 },
  { id: 'GD +1-473', label: '+1-473 (Grenada)', phoneLength: 7 },
  { id: 'AS +1-684', label: '+1-684 (American Samoa)', phoneLength: 7 },
  { id: 'LC +1-758', label: '+1-758 (Saint Lucia)', phoneLength: 7 },
  { id: 'DM +1-767', label: '+1-767 (Dominica)', phoneLength: 7 },
  {
    id: 'VC +1-784',
    label: '+1-784 (Saint Vincent and the Grenadines)',
    phoneLength: 7,
  },
  { id: 'DO +1-809', label: '+1-809 (Dominican Republic)', phoneLength: 7 },
  { id: 'TT +1-868', label: '+1-868 (Trinidad and Tobago)', phoneLength: 7 },
  { id: 'KN +1-869', label: '+1-869 (Saint Kitts and Nevis)', phoneLength: 7 },
  { id: 'JM +1-876', label: '+1-876 (Jamaica)', phoneLength: 7 },
  { id: 'EG +20', label: '+20 (Egypt)', phoneLength: 10 },
  { id: 'SS +211', label: '+211 (South Sudan)', phoneLength: 9 },
  { id: 'MA +212', label: '+212 (Morocco)', phoneLength: 9 },
  { id: 'DZ +213', label: '+213 (Algeria)', phoneLength: 9 },
  { id: 'TN +216', label: '+216 (Tunisia)', phoneLength: 8 },
  { id: 'LY +218', label: '+218 (Libya)', phoneLength: 9 },
  { id: 'GM +220', label: '+220 (Gambia)', phoneLength: 7 },
  { id: 'SN +221', label: '+221 (Senegal)', phoneLength: 9 },
  { id: 'MR +222', label: '+222 (Mauritania)', phoneLength: 8 },
  { id: 'ML +223', label: '+223 (Mali)', phoneLength: 8 },
  { id: 'GN +224', label: '+224 (Guinea)', phoneLength: 9 },
  { id: 'BF +226', label: '+226 (Burkina Faso)', phoneLength: 8 },
  { id: 'NE +227', label: '+227 (Niger)', phoneLength: 8 },
  { id: 'TG +228', label: '+228 (Togo)', phoneLength: 8 },
  { id: 'BJ +229', label: '+229 (Benin)', phoneLength: 8 },
  { id: 'MU +230', label: '+230 (Mauritius)', phoneLength: 8 },
  { id: 'LR +231', label: '+231 (Liberia)', phoneLength: 7 },
  { id: 'SL +232', label: '+232 (Sierra Leone)', phoneLength: 8 },
  { id: 'GH +233', label: '+233 (Ghana)', phoneLength: 9 },
  { id: 'NG +234', label: '+234 (Nigeria)', phoneLength: 10 },
  { id: 'TD +235', label: '+235 (Chad)', phoneLength: 8 },
  { id: 'CF +236', label: '+236 (Central African Republic)', phoneLength: 8 },
  { id: 'CM +237', label: '+237 (Cameroon)', phoneLength: 9 },
  { id: 'CV +238', label: '+238 (Cabo Verde)', phoneLength: 7 },
  { id: 'ST +239', label: '+239 (Sao Tome and Principe)', phoneLength: 7 },
  { id: 'GQ +240', label: '+240 (Equatorial Guinea)', phoneLength: 9 },
  { id: 'GA +241', label: '+241 (Gabon)', phoneLength: 8 },
  { id: 'CG +242', label: '+242 (Congo)', phoneLength: 9 },
  {
    id: 'CD +243',
    label: '+243 (Congo, The Democratic Republic of the)',
    phoneLength: 9,
  },
  { id: 'AO +244', label: '+244 (Angola)', phoneLength: 9 },
  { id: 'GW +245', label: '+245 (Guinea-Bissau)', phoneLength: 7 },
  { id: 'SC +248', label: '+248 (Seychelles)', phoneLength: 7 },
  { id: 'SD +249', label: '+249 (Sudan)', phoneLength: 9 },
  { id: 'RW +250', label: '+250 (Rwanda)', phoneLength: 9 },
  { id: 'ET +251', label: '+251 (Ethiopia)', phoneLength: 9 },
  { id: 'SO +252', label: '+252 (Somalia)', phoneLength: 8 },
  { id: 'DJ +253', label: '+253 (Djibouti)', phoneLength: 6 },
  { id: 'KE +254', label: '+254 (Kenya)', phoneLength: 9 },
  {
    id: 'TZ +255',
    label: '+255 (Tanzania, United Republic of)',
    phoneLength: 9,
  },
  { id: 'UG +256', label: '+256 (Uganda)', phoneLength: 9 },
  { id: 'BI +257', label: '+257 (Burundi)', phoneLength: 8 },
  { id: 'MZ +258', label: '+258 (Mozambique)', phoneLength: 9 },
  { id: 'ZM +260', label: '+260 (Zambia)', phoneLength: 9 },
  { id: 'MG +261', label: '+261 (Madagascar)', phoneLength: 9 },
  { id: 'ZW +263', label: '+263 (Zimbabwe)', phoneLength: 9 },
  { id: 'NA +264', label: '+264 (Namibia)', phoneLength: 9 },
  { id: 'MW +265', label: '+265 (Malawi)', phoneLength: 9 },
  { id: 'LS +266', label: '+266 (Lesotho)', phoneLength: 8 },
  { id: 'BW +267', label: '+267 (Botswana)', phoneLength: 8 },
  { id: 'KM +269', label: '+269 (Comoros)', phoneLength: 7 },
  { id: 'ZA +27', label: '+27 (South Africa)', phoneLength: 9 },
  { id: 'ER +291', label: '+291 (Eritrea)', phoneLength: 7 },
  { id: 'AW +297', label: '+297 (Aruba)', phoneLength: 7 },
  { id: 'GR +30', label: '+30 (Greece)', phoneLength: 10 },
  { id: 'NL +31', label: '+31 (Netherlands)', phoneLength: 9 },
  { id: 'BE +32', label: '+32 (Belgium)', phoneLength: 9 },
  { id: 'FR +33', label: '+33 (France)', phoneLength: 9 },
  { id: 'ES +34', label: '+34 (Spain)', phoneLength: 9 },
  { id: 'PT +351', label: '+351 (Portugal)', phoneLength: 9 },
  { id: 'LU +352', label: '+352 (Luxembourg)', phoneLength: 9 },
  { id: 'IE +353', label: '+353 (Ireland)', phoneLength: 9 },
  { id: 'IS +354', label: '+354 (Iceland)', phoneLength: 7 },
  { id: 'AL +355', label: '+355 (Albania)', phoneLength: 9 },
  { id: 'MT +356', label: '+356 (Malta)', phoneLength: 8 },
  { id: 'CY +357', label: '+357 (Cyprus)', phoneLength: 8 },
  { id: 'FI +358', label: '+358 (Finland)', phoneLength: 10 },
  { id: 'BG +359', label: '+359 (Bulgaria)', phoneLength: 9 },
  { id: 'HU +36', label: '+36 (Hungary)', phoneLength: 9 },
  { id: 'LT +370', label: '+370 (Lithuania)', phoneLength: 8 },
  { id: 'LV +371', label: '+371 (Latvia)', phoneLength: 8 },
  { id: 'EE +372', label: '+372 (Estonia)', phoneLength: 8 },
  { id: 'MD +373', label: '+373 (Moldova, Republic of)', phoneLength: 8 },
  { id: 'AM +374', label: '+374 (Armenia)', phoneLength: 8 },
  { id: 'BY +375', label: '+375 (Belarus)', phoneLength: 9 },
  { id: 'AD +376', label: '+376 (Andorra)', phoneLength: 6 },
  { id: 'MC +377', label: '+377 (Monaco)', phoneLength: 8 },
  { id: 'SM +378', label: '+378 (San Marino)', phoneLength: 6 },
  { id: 'UA +380', label: '+380 (Ukraine)', phoneLength: 9 },
  { id: 'RS +381', label: '+381 (Serbia)', phoneLength: 9 },
  { id: 'ME +382', label: '+382 (Montenegro)', phoneLength: 8 },
  { id: 'HR +385', label: '+385 (Croatia)', phoneLength: 9 },
  { id: 'SI +386', label: '+386 (Slovenia)', phoneLength: 8 },
  { id: 'BA +387', label: '+387 (Bosnia and Herzegovina)', phoneLength: 8 },
  { id: 'IT +39', label: '+39 (Italy)', phoneLength: 10 },
  { id: 'RO +40', label: '+40 (Romania)', phoneLength: 9 },
  { id: 'CH +41', label: '+41 (Switzerland)', phoneLength: 9 },
  { id: 'CZ +420', label: '+420 (Czechia)', phoneLength: 9 },
  { id: 'SK +421', label: '+421 (Slovakia)', phoneLength: 9 },
  { id: 'LI +423', label: '+423 (Liechtenstein)', phoneLength: 7 },
  { id: 'AT +43', label: '+43 (Austria)', phoneLength: 10 },
  { id: 'GB +44', label: '+44 (United Kingdom)', phoneLength: 10 },
  { id: 'DK +45', label: '+45 (Denmark)', phoneLength: 8 },
  { id: 'SE +46', label: '+46 (Sweden)', phoneLength: 9 },
  { id: 'NO +47', label: '+47 (Norway)', phoneLength: 8 },
  { id: 'PL +48', label: '+48 (Poland)', phoneLength: 9 },
  { id: 'DE +49', label: '+49 (Germany)', phoneLength: 11 },
  { id: 'BZ +501', label: '+501 (Belize)', phoneLength: 7 },
  { id: 'GT +502', label: '+502 (Guatemala)', phoneLength: 8 },
  { id: 'SV +503', label: '+503 (El Salvador)', phoneLength: 8 },
  { id: 'HN +504', label: '+504 (Honduras)', phoneLength: 8 },
  { id: 'NI +505', label: '+505 (Nicaragua)', phoneLength: 8 },
  { id: 'CR +506', label: '+506 (Costa Rica)', phoneLength: 8 },
  { id: 'PA +507', label: '+507 (Panama)', phoneLength: 8 },
  { id: 'HT +509', label: '+509 (Haiti)', phoneLength: 8 },
  { id: 'PE +51', label: '+51 (Peru)', phoneLength: 9 },
  { id: 'MX +52', label: '+52 (Mexico)', phoneLength: 10 },
  { id: 'CU +53', label: '+53 (Cuba)', phoneLength: 8 },
  { id: 'AR +54', label: '+54 (Argentina)', phoneLength: 10 },
  { id: 'BR +55', label: '+55 (Brazil)', phoneLength: 11 },
  { id: 'CL +56', label: '+56 (Chile)', phoneLength: 9 },
  { id: 'CO +57', label: '+57 (Colombia)', phoneLength: 10 },
  {
    id: 'VE +58',
    label: '+58 (Venezuela, Bolivarian Republic of)',
    phoneLength: 10,
  },
  {
    id: 'BO +591',
    label: '+591 (Bolivia, Plurinational State of)',
    phoneLength: 8,
  },
  { id: 'GY +592', label: '+592 (Guyana)', phoneLength: 7 },
  { id: 'EC +593', label: '+593 (Ecuador)', phoneLength: 9 },
  { id: 'PY +595', label: '+595 (Paraguay)', phoneLength: 9 },
  { id: 'SR +597', label: '+597 (Suriname)', phoneLength: 7 },
  { id: 'UY +598', label: '+598 (Uruguay)', phoneLength: 8 },
  { id: 'MY +60', label: '+60 (Malaysia)', phoneLength: 9 },
  { id: 'AU +61', label: '+61 (Australia)', phoneLength: 9 },
  { id: 'ID +62', label: '+62 (Indonesia)', phoneLength: 10 },
  { id: 'PH +63', label: '+63 (Philippines)', phoneLength: 10 },
  { id: 'NZ +64', label: '+64 (New Zealand)', phoneLength: 9 },
  { id: 'SG +65', label: '+65 (Singapore)', phoneLength: 8 },
  { id: 'TH +66', label: '+66 (Thailand)', phoneLength: 9 },
  { id: 'TL +670', label: '+670 (Timor-Leste)', phoneLength: 8 },
  { id: 'AQ +672', label: '+672 (Antarctica)', phoneLength: 6 },
  { id: 'BN +673', label: '+673 (Brunei Darussalam)', phoneLength: 7 },
  { id: 'NR +674', label: '+674 (Nauru)', phoneLength: 7 },
  { id: 'PG +675', label: '+675 (Papua New Guinea)', phoneLength: 8 },
  { id: 'TO +676', label: '+676 (Tonga)', phoneLength: 5 },
  { id: 'SB +677', label: '+677 (Solomon Islands)', phoneLength: 7 },
  { id: 'VU +678', label: '+678 (Vanuatu)', phoneLength: 7 },
  { id: 'FJ +679', label: '+679 (Fiji)', phoneLength: 7 },
  { id: 'PW +680', label: '+680 (Palau)', phoneLength: 7 },
  { id: 'WS +685', label: '+685 (Samoa)', phoneLength: 5 },
  { id: 'KI +686', label: '+686 (Kiribati)', phoneLength: 5 },
  {
    id: 'FM +691',
    label: '+691 (Micronesia, Federated States of)',
    phoneLength: 7,
  },
  { id: 'MH +692', label: '+692 (Marshall Islands)', phoneLength: 7 },
  { id: 'KZ +7', label: '+7 (Kazakhstan)', phoneLength: 10 },
  { id: 'RU +7', label: '+7 (Russian Federation)', phoneLength: 10 },
  { id: 'JP +81', label: '+81 (Japan)', phoneLength: 10 },
  { id: 'KR +82', label: '+82 (Korea, Republic of)', phoneLength: 10 },
  { id: 'VN +84', label: '+84 (Viet Nam)', phoneLength: 9 },
  { id: 'KH +855', label: '+855 (Cambodia)', phoneLength: 9 },
  {
    id: 'LA +856',
    label: "+856 (Lao People's Democratic Republic)",
    phoneLength: 8,
  },
  { id: 'CN +86', label: '+86 (China)', phoneLength: 11 },
  { id: 'BD +880', label: '+880 (Bangladesh)', phoneLength: 10 },
  { id: 'TW +886', label: '+886 (Taiwan, Province of China)', phoneLength: 9 },
  { id: 'TR +90', label: '+90 (Turkey)', phoneLength: 10 },
  { id: 'IN +91', label: '+91 (India)', phoneLength: 10 },
  { id: 'PK +92', label: '+92 (Pakistan)', phoneLength: 10 },
  { id: 'AF +93', label: '+93 (Afghanistan)', phoneLength: 9 },
  { id: 'LK +94', label: '+94 (Sri Lanka)', phoneLength: 9 },
  { id: 'MM +95', label: '+95 (Myanmar)', phoneLength: 9 },
  { id: 'MV +960', label: '+960 (Maldives)', phoneLength: 7 },
  { id: 'LB +961', label: '+961 (Lebanon)', phoneLength: 8 },
  { id: 'JO +962', label: '+962 (Jordan)', phoneLength: 9 },
  { id: 'SY +963', label: '+963 (Syrian Arab Republic)', phoneLength: 9 },
  { id: 'IQ +964', label: '+964 (Iraq)', phoneLength: 10 },
  { id: 'KW +965', label: '+965 (Kuwait)', phoneLength: 8 },
  { id: 'SA +966', label: '+966 (Saudi Arabia)', phoneLength: 9 },
  { id: 'YE +967', label: '+967 (Yemen)', phoneLength: 9 },
  { id: 'OM +968', label: '+968 (Oman)', phoneLength: 8 },
  { id: 'AE +971', label: '+971 (United Arab Emirates)', phoneLength: 9 },
  { id: 'IL +972', label: '+972 (Israel)', phoneLength: 9 },
  { id: 'BH +973', label: '+973 (Bahrain)', phoneLength: 8 },
  { id: 'QA +974', label: '+974 (Qatar)', phoneLength: 8 },
  { id: 'BT +975', label: '+975 (Bhutan)', phoneLength: 8 },
  { id: 'MN +976', label: '+976 (Mongolia)', phoneLength: 8 },
  { id: 'NP +977', label: '+977 (Nepal)', phoneLength: 10 },
  { id: 'IR +98', label: '+98 (Iran, Islamic Republic of)', phoneLength: 10 },
  { id: 'TJ +992', label: '+992 (Tajikistan)', phoneLength: 9 },
  { id: 'TM +993', label: '+993 (Turkmenistan)', phoneLength: 8 },
  { id: 'AZ +994', label: '+994 (Azerbaijan)', phoneLength: 9 },
  { id: 'GE +995', label: '+995 (Georgia)', phoneLength: 9 },
  { id: 'KG +996', label: '+996 (Kyrgyzstan)', phoneLength: 9 },
  { id: 'UZ +998', label: '+998 (Uzbekistan)', phoneLength: 9 },
]

export const registerCountryCodeOptions = [
  { code: 'US +1', label: '🇺🇸 +1', phoneLength: 10 },
  { code: 'BS +1-242', label: '🇧🇸 +1-242', phoneLength: 7 },
  { code: 'BB +1-246', label: '🇧🇧 +1-246', phoneLength: 7 },
  { code: 'AI +1-264', label: '🇦🇮 +1-264', phoneLength: 7 },
  { code: 'AG +1-268', label: '🇦🇬 +1-268', phoneLength: 7 },
  { code: 'BM +1-441', label: '🇧🇲 +1-441', phoneLength: 7 },
  { code: 'GD +1-473', label: '🇬🇩 +1-473', phoneLength: 7 },
  { code: 'AS +1-684', label: '🇦🇸 +1-684', phoneLength: 7 },
  { code: 'LC +1-758', label: '🇱🇨 +1-758', phoneLength: 7 },
  { code: 'DM +1-767', label: '🇩🇲 +1-767', phoneLength: 7 },
  { code: 'VC +1-784', label: '🇻🇨 +1-784', phoneLength: 7 },
  { code: 'DO +1-809', label: '🇩🇴 +1-809', phoneLength: 7 },
  { code: 'TT +1-868', label: '🇹🇹 +1-868', phoneLength: 7 },
  { code: 'KN +1-869', label: '🇰🇳 +1-869', phoneLength: 7 },
  { code: 'JM +1-876', label: '🇯🇲 +1-876', phoneLength: 7 },
  { code: 'KZ +7', label: '🇰🇿 +7', phoneLength: 10 },
  { code: 'RU +7', label: '🇷🇺 +7', phoneLength: 10 },
  { code: 'EG +20', label: '🇪🇬 +20', phoneLength: 10 },
  { code: 'ZA +27', label: '🇿🇦 +27', phoneLength: 9 },
  { code: 'GR +30', label: '🇬🇷 +30', phoneLength: 10 },
  { code: 'NL +31', label: '🇳🇱 +31', phoneLength: 9 },
  { code: 'BE +32', label: '🇧🇪 +32', phoneLength: 9 },
  { code: 'FR +33', label: '🇫🇷 +33', phoneLength: 9 },
  { code: 'ES +34', label: '🇪🇸 +34', phoneLength: 9 },
  { code: 'HU +36', label: '🇭🇺 +36', phoneLength: 9 },
  { code: 'IT +39', label: '🇮🇹 +39', phoneLength: 10 },
  { code: 'RO +40', label: '🇷🇴 +40', phoneLength: 9 },
  { code: 'CH +41', label: '🇨🇭 +41', phoneLength: 9 },
  { code: 'AT +43', label: '🇦🇹 +43', phoneLength: 10 },
  { code: 'GB +44', label: '🇬🇧 +44', phoneLength: 10 },
  { code: 'DK +45', label: '🇩🇰 +45', phoneLength: 8 },
  { code: 'SE +46', label: '🇸🇪 +46', phoneLength: 9 },
  { code: 'NO +47', label: '🇳🇴 +47', phoneLength: 8 },
  { code: 'PL +48', label: '🇵🇱 +48', phoneLength: 9 },
  { code: 'DE +49', label: '🇩🇪 +49', phoneLength: 11 },
  { code: 'PE +51', label: '🇵🇪 +51', phoneLength: 9 },
  { code: 'MX +52', label: '🇲🇽 +52', phoneLength: 10 },
  { code: 'CU +53', label: '🇨🇺 +53', phoneLength: 8 },
  { code: 'AR +54', label: '🇦🇷 +54', phoneLength: 10 },
  { code: 'BR +55', label: '🇧🇷 +55', phoneLength: 11 },
  { code: 'CL +56', label: '🇨🇱 +56', phoneLength: 9 },
  { code: 'CO +57', label: '🇨🇴 +57', phoneLength: 10 },
  { code: 'VE +58', label: '🇻🇪 +58', phoneLength: 10 },
  { code: 'MY +60', label: '🇲🇾 +60', phoneLength: 9 },
  { code: 'AU +61', label: '🇦🇺 +61', phoneLength: 9 },
  { code: 'ID +62', label: '🇮🇩 +62', phoneLength: 10 },
  { code: 'PH +63', label: '🇵🇭 +63', phoneLength: 10 },
  { code: 'NZ +64', label: '🇳🇿 +64', phoneLength: 9 },
  { code: 'SG +65', label: '🇸🇬 +65', phoneLength: 8 },
  { code: 'TH +66', label: '🇹🇭 +66', phoneLength: 9 },
  { code: 'JP +81', label: '🇯🇵 +81', phoneLength: 10 },
  { code: 'KR +82', label: '🇰🇷 +82', phoneLength: 10 },
  { code: 'VN +84', label: '🇻🇳 +84', phoneLength: 9 },
  { code: 'CN +86', label: '🇨🇳 +86', phoneLength: 11 },
  { code: 'TR +90', label: '🇹🇷 +90', phoneLength: 10 },
  { code: 'IN +91', label: '🇮🇳 +91', phoneLength: 10 },
  { code: 'PK +92', label: '🇵🇰 +92', phoneLength: 10 },
  { code: 'AF +93', label: '🇦🇫 +93', phoneLength: 9 },
  { code: 'LK +94', label: '🇱🇰 +94', phoneLength: 9 },
  { code: 'MM +95', label: '🇲🇲 +95', phoneLength: 9 },
  { code: 'IR +98', label: '🇮🇷 +98', phoneLength: 10 },
  { code: 'SS +211', label: '🇸🇸 +211', phoneLength: 9 },
  { code: 'MA +212', label: '🇲🇦 +212', phoneLength: 9 },
  { code: 'DZ +213', label: '🇩🇿 +213', phoneLength: 9 },
  { code: 'TN +216', label: '🇹🇳 +216', phoneLength: 8 },
  { code: 'LY +218', label: '🇱🇾 +218', phoneLength: 9 },
  { code: 'GM +220', label: '🇬🇲 +220', phoneLength: 7 },
  { code: 'SN +221', label: '🇸🇳 +221', phoneLength: 9 },
  { code: 'MR +222', label: '🇲🇷 +222', phoneLength: 8 },
  { code: 'ML +223', label: '🇲🇱 +223', phoneLength: 8 },
  { code: 'GN +224', label: '🇬🇳 +224', phoneLength: 9 },
  { code: 'BF +226', label: '🇧🇫 +226', phoneLength: 8 },
  { code: 'NE +227', label: '🇳🇪 +227', phoneLength: 8 },
  { code: 'TG +228', label: '🇹🇬 +228', phoneLength: 8 },
  { code: 'BJ +229', label: '🇧🇯 +229', phoneLength: 8 },
  { code: 'MU +230', label: '🇲🇺 +230', phoneLength: 8 },
  { code: 'LR +231', label: '🇱🇷 +231', phoneLength: 7 },
  { code: 'SL +232', label: '🇸🇱 +232', phoneLength: 8 },
  { code: 'GH +233', label: '🇬🇭 +233', phoneLength: 9 },
  { code: 'NG +234', label: '🇳🇬 +234', phoneLength: 10 },
  { code: 'TD +235', label: '🇹🇩 +235', phoneLength: 8 },
  { code: 'CF +236', label: '🇨🇫 +236', phoneLength: 8 },
  { code: 'CM +237', label: '🇨🇲 +237', phoneLength: 9 },
  { code: 'CV +238', label: '🇨🇻 +238', phoneLength: 7 },
  { code: 'ST +239', label: '🇸🇹 +239', phoneLength: 7 },
  { code: 'GQ +240', label: '🇬🇶 +240', phoneLength: 9 },
  { code: 'GA +241', label: '🇬🇦 +241', phoneLength: 8 },
  { code: 'CG +242', label: '🇨🇬 +242', phoneLength: 9 },
  { code: 'CD +243', label: '🇨🇩 +243', phoneLength: 9 },
  { code: 'AO +244', label: '🇦🇴 +244', phoneLength: 9 },
  { code: 'GW +245', label: '🇬🇼 +245', phoneLength: 7 },
  { code: 'SC +248', label: '🇸🇨 +248', phoneLength: 7 },
  { code: 'SD +249', label: '🇸🇩 +249', phoneLength: 9 },
  { code: 'RW +250', label: '🇷🇼 +250', phoneLength: 9 },
  { code: 'ET +251', label: '🇪🇹 +251', phoneLength: 9 },
  { code: 'SO +252', label: '🇸🇴 +252', phoneLength: 8 },
  { code: 'DJ +253', label: '🇩🇯 +253', phoneLength: 6 },
  { code: 'KE +254', label: '🇰🇪 +254', phoneLength: 9 },
  { code: 'TZ +255', label: '🇹🇿 +255', phoneLength: 9 },
  { code: 'UG +256', label: '🇺🇬 +256', phoneLength: 9 },
  { code: 'BI +257', label: '🇧🇮 +257', phoneLength: 8 },
  { code: 'MZ +258', label: '🇲🇿 +258', phoneLength: 9 },
  { code: 'ZM +260', label: '🇿🇲 +260', phoneLength: 9 },
  { code: 'MG +261', label: '🇲🇬 +261', phoneLength: 9 },
  { code: 'ZW +263', label: '🇿🇼 +263', phoneLength: 9 },
  { code: 'NA +264', label: '🇳🇦 +264', phoneLength: 9 },
  { code: 'MW +265', label: '🇲🇼 +265', phoneLength: 9 },
  { code: 'LS +266', label: '🇱🇸 +266', phoneLength: 8 },
  { code: 'BW +267', label: '🇧🇼 +267', phoneLength: 8 },
  { code: 'KM +269', label: '🇰🇲 +269', phoneLength: 7 },
  { code: 'ER +291', label: '🇪🇷 +291', phoneLength: 7 },
  { code: 'AW +297', label: '🇦🇼 +297', phoneLength: 7 },
  { code: 'PT +351', label: '🇵🇹 +351', phoneLength: 9 },
  { code: 'LU +352', label: '🇱🇺 +352', phoneLength: 9 },
  { code: 'IE +353', label: '🇮🇪 +353', phoneLength: 9 },
  { code: 'IS +354', label: '🇮🇸 +354', phoneLength: 7 },
  { code: 'AL +355', label: '🇦🇱 +355', phoneLength: 9 },
  { code: 'MT +356', label: '🇲🇹 +356', phoneLength: 8 },
  { code: 'CY +357', label: '🇨🇾 +357', phoneLength: 8 },
  { code: 'FI +358', label: '🇫🇮 +358', phoneLength: 10 },
  { code: 'BG +359', label: '🇧🇬 +359', phoneLength: 9 },
  { code: 'LT +370', label: '🇱🇹 +370', phoneLength: 8 },
  { code: 'LV +371', label: '🇱🇻 +371', phoneLength: 8 },
  { code: 'EE +372', label: '🇪🇪 +372', phoneLength: 8 },
  { code: 'MD +373', label: '🇲🇩 +373', phoneLength: 8 },
  { code: 'AM +374', label: '🇦🇲 +374', phoneLength: 8 },
  { code: 'BY +375', label: '🇧🇾 +375', phoneLength: 9 },
  { code: 'AD +376', label: '🇦🇩 +376', phoneLength: 6 },
  { code: 'MC +377', label: '🇲🇨 +377', phoneLength: 8 },
  { code: 'SM +378', label: '🇸🇲 +378', phoneLength: 6 },
  { code: 'UA +380', label: '🇺🇦 +380', phoneLength: 9 },
  { code: 'RS +381', label: '🇷🇸 +381', phoneLength: 9 },
  { code: 'ME +382', label: '🇲🇪 +382', phoneLength: 8 },
  { code: 'HR +385', label: '🇭🇷 +385', phoneLength: 9 },
  { code: 'SI +386', label: '🇸🇮 +386', phoneLength: 8 },
  { code: 'BA +387', label: '🇧🇦 +387', phoneLength: 8 },
  { code: 'CZ +420', label: '🇨🇿 +420', phoneLength: 9 },
  { code: 'SK +421', label: '🇸🇰 +421', phoneLength: 9 },
  { code: 'LI +423', label: '🇱🇮 +423', phoneLength: 7 },
  { code: 'BZ +501', label: '🇧🇿 +501', phoneLength: 7 },
  { code: 'GT +502', label: '🇬🇹 +502', phoneLength: 8 },
  { code: 'SV +503', label: '🇸🇻 +503', phoneLength: 8 },
  { code: 'HN +504', label: '🇭🇳 +504', phoneLength: 8 },
  { code: 'NI +505', label: '🇳🇮 +505', phoneLength: 8 },
  { code: 'CR +506', label: '🇨🇷 +506', phoneLength: 8 },
  { code: 'PA +507', label: '🇵🇦 +507', phoneLength: 8 },
  { code: 'HT +509', label: '🇭🇹 +509', phoneLength: 8 },
  { code: 'BO +591', label: '🇧🇴 +591', phoneLength: 8 },
  { code: 'GY +592', label: '🇬🇾 +592', phoneLength: 7 },
  { code: 'EC +593', label: '🇪🇨 +593', phoneLength: 9 },
  { code: 'PY +595', label: '🇵🇾 +595', phoneLength: 9 },
  { code: 'SR +597', label: '🇸🇷 +597', phoneLength: 7 },
  { code: 'UY +598', label: '🇺🇾 +598', phoneLength: 8 },
  { code: 'TL +670', label: '🇹🇱 +670', phoneLength: 8 },
  { code: 'AQ +672', label: '🇦🇶 +672', phoneLength: 6 },
  { code: 'BN +673', label: '🇧🇳 +673', phoneLength: 7 },
  { code: 'NR +674', label: '🇳🇷 +674', phoneLength: 7 },
  { code: 'PG +675', label: '🇵🇬 +675', phoneLength: 8 },
  { code: 'TO +676', label: '🇹🇴 +676', phoneLength: 5 },
  { code: 'SB +677', label: '🇸🇧 +677', phoneLength: 7 },
  { code: 'VU +678', label: '🇻🇺 +678', phoneLength: 7 },
  { code: 'FJ +679', label: '🇫🇯 +679', phoneLength: 7 },
  { code: 'PW +680', label: '🇵🇼 +680', phoneLength: 7 },
  { code: 'WS +685', label: '🇼🇸 +685', phoneLength: 5 },
  { code: 'KI +686', label: '🇰🇮 +686', phoneLength: 5 },
  { code: 'FM +691', label: '🇫🇲 +691', phoneLength: 7 },
  { code: 'MH +692', label: '🇲🇭 +692', phoneLength: 7 },
  { code: 'KH +855', label: '🇰🇭 +855', phoneLength: 9 },
  { code: 'LA +856', label: '🇱🇦 +856', phoneLength: 8 },
  { code: 'BD +880', label: '🇧🇩 +880', phoneLength: 10 },
  { code: 'TW +886', label: '🇹🇼 +886', phoneLength: 9 },
  { code: 'MV +960', label: '🇲🇻 +960', phoneLength: 7 },
  { code: 'LB +961', label: '🇱🇧 +961', phoneLength: 8 },
  { code: 'JO +962', label: '🇯🇴 +962', phoneLength: 9 },
  { code: 'SY +963', label: '🇸🇾 +963', phoneLength: 9 },
  { code: 'IQ +964', label: '🇮🇶 +964', phoneLength: 10 },
  { code: 'KW +965', label: '🇰🇼 +965', phoneLength: 8 },
  { code: 'SA +966', label: '🇸🇦 +966', phoneLength: 9 },
  { code: 'YE +967', label: '🇾🇪 +967', phoneLength: 9 },
  { code: 'OM +968', label: '🇴🇲 +968', phoneLength: 8 },
  { code: 'AE +971', label: '🇦🇪 +971', phoneLength: 9 },
  { code: 'IL +972', label: '🇮🇱 +972', phoneLength: 9 },
  { code: 'BH +973', label: '🇧🇭 +973', phoneLength: 8 },
  { code: 'QA +974', label: '🇶🇦 +974', phoneLength: 8 },
  { code: 'BT +975', label: '🇧🇹 +975', phoneLength: 8 },
  { code: 'MN +976', label: '🇲🇳 +976', phoneLength: 8 },
  { code: 'NP +977', label: '🇳🇵 +977', phoneLength: 10 },
  { code: 'TJ +992', label: '🇹🇯 +992', phoneLength: 9 },
  { code: 'TM +993', label: '🇹🇲 +993', phoneLength: 8 },
  { code: 'AZ +994', label: '🇦🇿 +994', phoneLength: 9 },
  { code: 'GE +995', label: '🇬🇪 +995', phoneLength: 9 },
  { code: 'KG +996', label: '🇰🇬 +996', phoneLength: 9 },
  { code: 'UZ +998', label: '🇺🇿 +998', phoneLength: 9 },
]

export const countryOptions = [
  { id: 'united_states', label: 'United States' },
  { id: 'bahamas', label: 'Bahamas' },
  { id: 'barbados', label: 'Barbados' },
  { id: 'anguilla', label: 'Anguilla' },
  { id: 'antigua_and_barbuda', label: 'Antigua and Barbuda' },
  { id: 'bermuda', label: 'Bermuda' },
  { id: 'grenada', label: 'Grenada' },
  { id: 'american_samoa', label: 'American Samoa' },
  { id: 'saint_lucia', label: 'Saint Lucia' },
  { id: 'dominica', label: 'Dominica' },
  { id: 'saint_vincent_and_the_grenadines', label: 'Saint Vincent and the Grenadines' },
  { id: 'dominican_republic', label: 'Dominican Republic' },
  { id: 'trinidad_and_tobago', label: 'Trinidad and Tobago' },
  { id: 'saint_kitts_and_nevis', label: 'Saint Kitts and Nevis' },
  { id: 'jamaica', label: 'Jamaica' },
  { id: 'egypt', label: 'Egypt' },
  { id: 'south_sudan', label: 'South Sudan' },
  { id: 'morocco', label: 'Morocco' },
  { id: 'algeria', label: 'Algeria' },
  { id: 'tunisia', label: 'Tunisia' },
  { id: 'libya', label: 'Libya' },
  { id: 'gambia', label: 'Gambia' },
  { id: 'senegal', label: 'Senegal' },
  { id: 'mauritania', label: 'Mauritania' },
  { id: 'mali', label: 'Mali' },
  { id: 'guinea', label: 'Guinea' },
  { id: 'burkina_faso', label: 'Burkina Faso' },
  { id: 'niger', label: 'Niger' },
  { id: 'benin', label: 'Benin' },
  { id: 'mauritius', label: 'Mauritius' },
  { id: 'liberia', label: 'Liberia' },
  { id: 'sierra_leone', label: 'Sierra Leone' },
  { id: 'ghana', label: 'Ghana' },
  { id: 'nigeria', label: 'Nigeria' },
  { id: 'chad', label: 'Chad' },
  { id: 'central_african_republic', label: 'Central African Republic' },
  { id: 'cameroon', label: 'Cameroon' },
  { id: 'cabo_verde', label: 'Cabo Verde' },
  { id: 'sao_tome_and_principe', label: 'Sao Tome and Principe' },
  { id: 'equatorial_guinea', label: 'Equatorial Guinea' },
  { id: 'gabon', label: 'Gabon' },
  { id: 'congo', label: 'Congo' },
  { id: 'democratic_republic_of_the_congo', label: 'Congo, The Democratic Republic of the' },
  { id: 'angola', label: 'Angola' },
  { id: 'guinea_bissau', label: 'Guinea-Bissau' },
  { id: 'seychelles', label: 'Seychelles' },
  { id: 'sudan', label: 'Sudan' },
  { id: 'rwanda', label: 'Rwanda' },
  { id: 'ethiopia', label: 'Ethiopia' },
  { id: 'somalia', label: 'Somalia' },
  { id: 'djibouti', label: 'Djibouti' },
  { id: 'kenya', label: 'Kenya' },
  { id: 'tanzania_united_republic_of', label: 'Tanzania, United Republic of' },
  { id: 'uganda', label: 'Uganda' },
  { id: 'burundi', label: 'Burundi' },
  { id: 'mozambique', label: 'Mozambique' },
  { id: 'zambia', label: 'Zambia' },
  { id: 'madagascar', label: 'Madagascar' },
  { id: 'zimbabwe', label: 'Zimbabwe' },
  { id: 'namibia', label: 'Namibia' },
  { id: 'malawi', label: 'Malawi' },
  { id: 'lesotho', label: 'Lesotho' },
  { id: 'botswana', label: 'Botswana' },
  { id: 'comoros', label: 'Comoros' },
  { id: 'south_africa', label: 'South Africa' },
  { id: 'eritrea', label: 'Eritrea' },
  { id: 'aruba', label: 'Aruba' },
  { id: 'greece', label: 'Greece' },
  { id: 'netherlands', label: 'Netherlands' },
  { id: 'belgium', label: 'Belgium' },
  { id: 'france', label: 'France' },
  { id: 'spain', label: 'Spain' },
  { id: 'portugal', label: 'Portugal' },
  { id: 'luxembourg', label: 'Luxembourg' },
  { id: 'ireland', label: 'Ireland' },
  { id: 'iceland', label: 'Iceland' },
  { id: 'albania', label: 'Albania' },
  { id: 'malta', label: 'Malta' },
  { id: 'cyprus', label: 'Cyprus' },
  { id: 'finland', label: 'Finland' },
  { id: 'bulgaria', label: 'Bulgaria' },
  { id: 'hungary', label: 'Hungary' },
  { id: 'lithuania', label: 'Lithuania' },
  { id: 'latvia', label: 'Latvia' },
  { id: 'estonia', label: 'Estonia' },
  { id: 'moldova_republic_of', label: 'Moldova, Republic of' },
  { id: 'armenia', label: 'Armenia' },
  { id: 'belarus', label: 'Belarus' },
  { id: 'andorra', label: 'Andorra' },
  { id: 'monaco', label: 'Monaco' },
  { id: 'san_marino', label: 'San Marino' },
  { id: 'ukraine', label: 'Ukraine' },
  { id: 'serbia', label: 'Serbia' },
  { id: 'montenegro', label: 'Montenegro' },
  { id: 'croatia', label: 'Croatia' },
  { id: 'slovenia', label: 'Slovenia' },
  { id: 'bosnia_and_herzegovina', label: 'Bosnia and Herzegovina' },
  { id: 'italy', label: 'Italy' },
  { id: 'romania', label: 'Romania' },
  { id: 'switzerland', label: 'Switzerland' },
  { id: 'czechia', label: 'Czechia' },
  { id: 'slovakia', label: 'Slovakia' },
  { id: 'liechtenstein', label: 'Liechtenstein' },
  { id: 'austria', label: 'Austria' },
  { id: 'united_kingdom', label: 'United Kingdom' },
  { id: 'denmark', label: 'Denmark' },
  { id: 'sweden', label: 'Sweden' },
  { id: 'norway', label: 'Norway' },
  { id: 'poland', label: 'Poland' },
  { id: 'germany', label: 'Germany' },
  { id: 'belize', label: 'Belize' },
  { id: 'guatemala', label: 'Guatemala' },
  { id: 'el_salvador', label: 'El Salvador' },
  { id: 'honduras', label: 'Honduras' },
  { id: 'nicaragua', label: 'Nicaragua' },
  { id: 'costa_rica', label: 'Costa Rica' },
  { id: 'panama', label: 'Panama' },
  { id: 'haiti', label: 'Haiti' },
  { id: 'peru', label: 'Peru' },
  { id: 'mexico', label: 'Mexico' },
  { id: 'cuba', label: 'Cuba' },
  { id: 'argentina', label: 'Argentina' },
  { id: 'brazil', label: 'Brazil' },
  { id: 'chile', label: 'Chile' },
  { id: 'colombia', label: 'Colombia' },
  { id: 'venezuela_bolivarian_republic_of', label: 'Venezuela, Bolivarian Republic of' },
  { id: 'bolivia_plurinational_state_of', label: 'Bolivia, Plurinational State of' },
  { id: 'guyana', label: 'Guyana' },
  { id: 'ecuador', label: 'Ecuador' },
  { id: 'paraguay', label: 'Paraguay' },
  { id: 'suriname', label: 'Suriname' },
  { id: 'uruguay', label: 'Uruguay' },
  { id: 'malaysia', label: 'Malaysia' },
  { id: 'australia', label: 'Australia' },
  { id: 'indonesia', label: 'Indonesia' },
  { id: 'philippines', label: 'Philippines' },
  { id: 'new_zealand', label: 'New Zealand' },
  { id: 'singapore', label: 'Singapore' },
  { id: 'thailand', label: 'Thailand' },
  { id: 'timor_leste', label: 'Timor-Leste' },
  { id: 'antarctica', label: 'Antarctica' },
  { id: 'brunei_darussalam', label: 'Brunei Darussalam' },
  { id: 'nauru', label: 'Nauru' },
  { id: 'papua_new_guinea', label: 'Papua New Guinea' },
  { id: 'tonga', label: 'Tonga' },
  { id: 'solomon_islands', label: 'Solomon Islands' },
  { id: 'vanuatu', label: 'Vanuatu' },
  { id: 'fiji', label: 'Fiji' },
  { id: 'palau', label: 'Palau' },
  { id: 'samoa', label: 'Samoa' },
  { id: 'kiribati', label: 'Kiribati' },
  { id: 'micronesia_federated_states_of', label: 'Micronesia, Federated States of' },
  { id: 'marshall_islands', label: 'Marshall Islands' },
  { id: 'kazakhstan', label: 'Kazakhstan' },
  { id: 'russian_federation', label: 'Russian Federation' },
  { id: 'japan', label: 'Japan' },
  { id: 'korea_republic_of', label: 'Korea, Republic of' },
  { id: 'viet_nam', label: 'Viet Nam' },
  { id: 'cambodia', label: 'Cambodia' },
  { id: 'lao_peoples_democratic_republic', label: "Lao People's Democratic Republic" },
  { id: 'china', label: 'China' },
  { id: 'bangladesh', label: 'Bangladesh' },
  { id: 'taiwan_province_of_china', label: 'Taiwan, Province of China' },
  { id: 'turkey', label: 'Turkey' },
  { id: 'india', label: 'India' },
  { id: 'pakistan', label: 'Pakistan' },
  { id: 'afghanistan', label: 'Afghanistan' },
  { id: 'sri_lanka', label: 'Sri Lanka' },
  { id: 'myanmar', label: 'Myanmar' },
  { id: 'maldives', label: 'Maldives' },
  { id: 'lebanon', label: 'Lebanon' },
  { id: 'jordan', label: 'Jordan' },
  { id: 'syrian_arab_republic', label: 'Syrian Arab Republic' },
  { id: 'iraq', label: 'Iraq' },
  { id: 'kuwait', label: 'Kuwait' },
  { id: 'saudi_arabia', label: 'Saudi Arabia' },
  { id: 'yemen', label: 'Yemen' },
  { id: 'oman', label: 'Oman' },
  { id: 'united_arab_emirates', label: 'United Arab Emirates' },
  { id: 'israel', label: 'Israel' },
  { id: 'bahrain', label: 'Bahrain' },
  { id: 'qatar', label: 'Qatar' },
  { id: 'bhutan', label: 'Bhutan' },
  { id: 'mongolia', label: 'Mongolia' },
  { id: 'nepal', label: 'Nepal' },
  { id: 'iran_islamic_republic_of', label: 'Iran, Islamic Republic of' },
  { id: 'tajikistan', label: 'Tajikistan' },
  { id: 'turkmenistan', label: 'Turkmenistan' },
  { id: 'azerbaijan', label: 'Azerbaijan' },
  { id: 'georgia', label: 'Georgia' },
  { id: 'kyrgyzstan', label: 'Kyrgyzstan' },
  { id: 'uzbekistan', label: 'Uzbekistan' },
]

export const businessTypeOptions = [
  { id: 'sole_proprietorship', label: 'Sole Proprietorship' },
  { id: 'partnership', label: 'Partnership' },
  { id: 'limited_liability_company', label: 'Limited Liability Company (LLC)' },
  { id: 'corporation', label: 'Corporation' },
  { id: 'non_profit', label: 'Non-Profit Organization' },
  { id: 'cooperative', label: 'Cooperative' },
  { id: 'franchise', label: 'Franchise' },
  { id: 'government_entity', label: 'Government Entity' },
  { id: 'freelancer', label: 'Freelancer' },
  { id: 'startup', label: 'Startup' },
]

export const userGenderOptions = [
  { id: 'male', label: 'Male' },
  { id: 'female', label: 'Female' },
  { id: 'other', label: 'Other' },
]

export const userSignUpFormControls = [
  {
    name: 'name',
    label: 'Name',
    placeholder: 'Enter your name',
    type: 'text',
    componentType: 'input',
    className: 'border border-input-border-color px-3 py-6 rounded-sm text-gray-800',
    validations: [
      { required: true, message: 'Name is required' },
      { minLength: 2, message: 'Name must be at least 2 characters' },
      { maxLength: 50, message: 'Name must not exceed 50 characters' },
    ],
  },
  {
    name: 'email',
    label: 'Email',
    placeholder: 'Enter your email',
    type: 'email',
    componentType: 'input',
    className: 'border border-input-border-color px-3 py-6 rounded-sm text-gray-800',
    validations: [
      { required: true, message: 'Email is required' },
      {
        pattern: '^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$',
        message: 'Please enter a valid email address',
      },
    ],
  },

  {
    isGrouped: true,
    groupControls: [
      {
        name: 'country_code',
        label: 'Country Code',
        componentType: 'select',
        type: 'select',
        placeholder: 'Code',
        options: countryCodeOptions,
        className: 'border border-input-border-color rounded-sm w-full px-3 py-6 text-gray-800', // No padding here
        wrapperClassName: 'w-full', // For padding/margin
        basisClass: 'sm:w-full lg:basis-4/12', // Optional: Controls the width in the flex row
        validations: [{ required: true, message: 'Country code is required' }],
      },
      {
        name: 'mobile',
        label: 'Mobile Number',
        placeholder: 'Enter your mobile number',
        type: 'number',
        componentType: 'input',
        className:
          'border border-input-border-color px-3 py-6 rounded-sm w-full appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield] text-gray-800',
        wrapperClassName: 'w-full',
        basisClass: 'sm:w-full lg:basis-8/12', // Makes it take 75% of the row
        validations: [
          { required: true, message: 'Mobile number is required' },
          {
            pattern: '^[0-9]+$',
            message: 'Mobile number must contain only digits',
          },
          {
            custom: (value, formData) => {
              const countryCode = formData.country_code
              if (!countryCode) {
                return 'Please select a country code first'
              }
              const country = countryCodeOptions.find((opt) => opt.id === countryCode)
              if (!country) {
                return 'Invalid country code selected'
              }
              if (value.length !== country.phoneLength) {
                return `Mobile number must be exactly ${country.phoneLength} digits`
              }
              return null
            },
          },
        ],
      },
    ],
  },

  {
    name: 'address',
    label: 'Address',
    placeholder: 'Enter your  address',
    // type: "text",
    componentType: 'textarea',
    className: 'border border-input-border-color px-3 py-6 rounded-sm text-gray-800',
    validations: [
      { required: true, message: 'Address is required' },
      { minLength: 5, message: 'Please enter a complete address' },
    ],
  },

  {
    isGrouped: true,
    groupControls: [
      {
        name: 'city',
        label: 'City / District',
        componentType: 'input',
        type: 'text',
        placeholder: 'city',
        // options: countryCodeOptions,
        className: 'border border-input-border-color rounded-sm w-full px-3 py-6 text-gray-800', // No padding here
        wrapperClassName: 'w-full', // For padding/margin
        basisClass: 'sm:w-full lg:basis-6/12', // Optional: Controls the width in the flex row
        validations: [{ required: true, message: 'City is required' }],
      },
      {
        name: 'state',
        label: 'State / Province',
        componentType: 'input',
        type: 'text',
        placeholder: 'state',
        // options: countryCodeOptions,
        className: 'border border-input-border-color rounded-sm w-full px-3 py-6 text-gray-800', // No padding here
        wrapperClassName: 'w-full', // For padding/margin
        basisClass: 'sm:w-full lg:basis-6/12', // Optional: Controls the width in the flex row
        validations: [{ required: true, message: 'State is required' }],
      },
    ],
  },

  {
    isGrouped: true,
    groupControls: [
      {
        name: 'postal_code',
        label: 'Postal Code',
        componentType: 'input',
        type: 'number',
        placeholder: '123456',
        // options: countryCodeOptions,
        className: 'border border-input-border-color rounded-sm w-full px-3 py-6 text-gray-800', // No padding here
        wrapperClassName: 'w-full', // For padding/margin
        basisClass: 'sm:w-full lg:basis-6/12', // Optional: Controls the width in the flex row
        validations: [{ required: true, message: 'Postal code is required' }],
      },
      {
        name: 'country',
        label: 'Country',
        componentType: 'select',
        type: 'select',
        placeholder: 'select country',
        options: countryOptions,
        className: 'border border-input-border-color rounded-sm w-full px-3 py-6 text-gray-800', // No padding here
        wrapperClassName: 'w-full', // For padding/margin
        basisClass: 'sm:w-full lg:basis-6/12', // Optional: Controls the width in the flex row
        validations: [{ required: true, message: 'Country is required' }],
      },
    ],
  },

  {
    name: 'gender',
    label: 'Gender',
    componentType: 'select',
    type: 'text',
    placeholder: 'select your gender',
    options: userGenderOptions,
    className: 'border border-input-border-color rounded-sm w-full px-3 py-6 text-gray-800', // No padding here

    wrapperClassName: 'py-6 px-3 h-full', // Add this key for wrapper
    validations: [{ required: true, message: 'Gender is required' }],
  },

  {
    name: 'dob',
    label: 'Date of Birth',
    placeholder: 'select your dob',
    type: 'date',
    componentType: 'input',
    className: 'border border-input-border-color px-3 h-[50px] py-4 rounded-sm text-gray-800',
    validations: [
      { required: true, message: 'Date of Birth is required' },
      {
        custom: (rule, value) => {
          const selectedDate = new Date(value?.dob)
          const today = new Date()
          if (selectedDate >= today) {
            return 'Date of Birth must be in the past'
          }
        },
      },
    ],
  },

  {
    name: 'acceptTerms',
    label: 'I agree to all ',
    componentType: 'checkbox',
    validations: [
      {
        required: true,
        message: 'You must accept the Terms and Privacy Policy',
      },
    ],
  },
]

export const bussinessSignUpFormControls = [
  {
    name: 'business_name',
    label: 'Business Name',
    placeholder: 'Enter your Business name',
    type: 'text',
    componentType: 'input',
    className: 'border border-input-border-color px-3 py-6 rounded-sm text-gray-800',
    validations: [
      { required: true, message: 'Business name is required' },
      { minLength: 2, message: 'Business name must be at least 2 characters' },
    ],
  },
  {
    name: 'email',
    label: 'Business Email',
    placeholder: 'Enter your Business email',
    type: 'email',
    componentType: 'input',
    className: 'border border-input-border-color px-3 py-6 rounded-sm text-gray-800',
    validations: [
      { required: true, message: 'Business email is required' },
      {
        pattern: '^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$',
        message: 'Please enter a valid email address',
      },
    ],
  },
  {
    name: 'address',
    label: 'Address',
    placeholder: 'Enter your Business address',
    // type: "text",
    componentType: 'textarea',
    className: 'border border-input-border-color px-3 py-6 rounded-sm text-gray-800',
    validations: [
      { required: true, message: 'Business address is required' },
      { minLength: 5, message: 'Please enter a complete address' },
    ],
  },

  {
    name: 'business_type',
    label: 'Business Type',
    componentType: 'select',
    type: 'text',
    placeholder: 'select business type',
    options: businessTypeOptions,
    className: 'border border-input-border-color rounded-sm w-full text-gray-800', // No padding here
    wrapperClassName: 'py-6 px-3 h-full', // Add this key for wrapper
    validations: [{ required: true, message: 'Business type is required' }],
  },
  {
    isGrouped: true,
    groupControls: [
      {
        name: 'country_code',
        label: 'Country Code',
        componentType: 'select',
        type: 'select',
        placeholder: 'Code',
        options: countryCodeOptions,
        className: 'border border-input-border-color rounded-sm w-full text-gray-800', // No padding here
        wrapperClassName: 'w-full', // For padding/margin
        basisClass: 'sm:w-full lg:basis-4/12', // Optional: Controls the width in the flex row
        validations: [{ required: true, message: 'Country code is required' }],
        defaultValue: '+20',
      },
      {
        name: 'mobile',
        label: 'Mobile Number',
        placeholder: 'Enter your mobile number',
        type: 'number',
        componentType: 'input',
        className:
          'border border-input-border-color px-3 py-6 rounded-sm w-full appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield] text-gray-800',
        wrapperClassName: 'w-full', // For padding/margin
        basisClass: 'sm:w-full lg:basis-8/12', // Optional: Controls the width in the flex row
        validations: [
          { required: true, message: 'Mobile number is required' },
          {
            pattern: '^[0-9]+$',
            message: 'Mobile number must contain only digits',
          },
          {
            custom: (value, formData) => {
              const countryCode = formData.country_code

              if (!countryCode) {
                return 'Please select a country code first'
              }
              const country = countryCodeOptions.find((opt) => opt.id === countryCode)
              if (!country) {
                return 'Invalid country code selected'
              }
              if (value.length !== country.phoneLength) {
                return `Mobile number must be exactly ${country.phoneLength} digits`
              }
              return null
            },
          },
        ],
      },
    ],
  },

  {
    name: 'acceptTerms',
    label: 'I agree to all the ',
    componentType: 'checkbox',
    validations: [
      {
        required: true,
        message: 'You must accept the Terms and Privacy Policy',
      },
    ],
  },
]

export const initialBussinessSignUpFormControls = [
  {
    name: 'business_name',
    label: 'Business Name',
    placeholder: 'Enter your Business name',
    type: 'text',
    componentType: 'input',
    className: 'border border-input-border-color px-3 py-6 rounded-sm text-gray-800',
    validations: [
      { required: true, message: 'Business name is required' },
      { minLength: 2, message: 'Business name must be at least 2 characters' },
    ],
  },
  {
    name: 'email',
    label: 'Business Email',
    placeholder: 'Enter your Business email',
    type: 'email',
    componentType: 'input',
    className: 'border border-input-border-color px-3 py-6 rounded-sm text-gray-800',
    validations: [
      { required: true, message: 'Business email is required' },
      {
        pattern: '^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$',
        message: 'Please enter a valid email address',
      },
    ],
  },
  {
    name: 'address',
    label: 'Address',
    placeholder: 'Enter your Business address',
    // type: "text",
    componentType: 'textarea',
    className: 'border border-input-border-color px-3 py-6 rounded-sm text-gray-800',
    validations: [
      { required: true, message: 'Business address is required' },
      { minLength: 5, message: 'Please enter a complete address' },
    ],
  },

  {
    name: 'business_type',
    label: 'Business Type',
    componentType: 'select',
    type: 'text',
    placeholder: 'select business type',
    options: businessTypeOptions,
    className: 'border border-input-border-color rounded-sm w-full px-3 py-6 text-gray-800', // No padding here
    wrapperClassName: 'h-full', // Add this key for wrapper
    validations: [{ required: true, message: 'Business type is required' }],
  },
  {
    isGrouped: true,
    groupControls: [
      {
        name: 'country_code',
        label: 'Country Code',
        componentType: 'select',
        type: 'select',
        placeholder: 'Code',
        options: countryCodeOptions,
        className: 'border border-input-border-color rounded-sm w-full px-3 py-6 text-gray-800', // No padding here
        wrapperClassName: 'w-full ', // For padding/margin
        basisClass: 'sm:w-full lg:basis-4/12', // Optional: Controls the width in the flex row
        validations: [{ required: true, message: 'Country code is required' }],
        defaultValue: '+20',
      },
      {
        name: 'mobile',
        label: 'Mobile Number',
        placeholder: 'Enter your mobile number',
        type: 'number',
        componentType: 'input',
        className:
          'border border-input-border-color px-3 py-6 rounded-sm w-full appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield] text-gray-800',
        wrapperClassName: 'w-full', // For padding/margin
        basisClass: 'sm:w-full lg:basis-8/12', // Optional: Controls the width in the flex row
        validations: [
          { required: true, message: 'Mobile number is required' },
          {
            pattern: '^[0-9]+$',
            message: 'Mobile number must contain only digits',
          },
          {
            custom: (value, formData) => {
              const countryCode = formData.country_code
              if (!countryCode) {
                return 'Please select a country code first'
              }
              const country = countryCodeOptions.find((opt) => opt.id === countryCode)
              if (!country) {
                return 'Invalid country code selected'
              }
              if (value.length !== country.phoneLength) {
                return `Mobile number must be exactly ${country.phoneLength} digits`
              }
              return null
            },
          },
        ],
      },
    ],
  },

  {
    name: 'acceptTerms',
    label: 'I agree to all the ',
    componentType: 'checkbox',
    validations: [
      {
        required: true,
        message: 'You must accept the Terms and Privacy Policy',
      },
    ],
  },
]

export const userSignInFormControls = [
  {
    isGrouped: true,
    groupControls: [
      {
        name: 'country_code',
        label: 'Country Code',
        componentType: 'select',
        type: 'select',
        placeholder: 'Code',
        options: countryCodeOptions,
        className: 'border border-input-border-color rounded-sm w-full px-3 py-6 text-gray-800', // No padding here

        wrapperClassName: 'w-full', // For padding/margin
        basisClass: 'sm:w-full lg:basis-4/12', // Optional: Controls the width in the flex row
        validations: [{ required: true, message: 'Country code is required' }],
      },
      {
        name: 'mobile',
        label: 'Mobile Number',
        placeholder: 'Enter your mobile number',
        type: 'number',
        componentType: 'input',
        className:
          'border border-input-border-color px-3 py-6 rounded-sm w-full appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield] text-gray-800',
        wrapperClassName: 'w-full', // For padding/margin
        basisClass: 'sm:w-full lg:basis-8/12', // Optional: Controls the width in the flex row
        validations: [
          { required: true, message: 'Mobile number is required' },
          {
            custom: (value, formData) => {
              const countryCode = formData.country_code
              if (!countryCode) {
                return 'Please select a country code first'
              }
              const country = countryCodeOptions.find((opt) => opt.id === countryCode)
              if (!country) {
                return 'Invalid country code selected'
              }
              if (value.length !== country.phoneLength) {
                return `Mobile number must be exactly ${country.phoneLength} digits`
              }
              return null
            },
          },
        ],
      },
    ],
  },
]

export const bussinessSignInFormControls = [
  {
    name: 'email',
    label: 'Business Email',
    placeholder: 'Enter your business email',
    type: 'email',
    componentType: 'input',
    className: 'border border-input-border-color px-3 py-6 rounded-sm text-gray-800',
    validations: [
      { required: true, message: 'Email is required' },
      {
        pattern: '^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$',
        message: 'Please enter a valid email address',
      },
    ],
  },
  {
    name: 'password',
    label: 'Business Password',
    placeholder: 'Enter your Password',
    type: 'password',
    componentType: 'input',
    className: 'border border-input-border-color px-3 py-6 rounded-sm text-gray-800',
    validations: [
      { required: true, message: 'Password is required' },
      // { minLength: 8, message: "Password must be at least 8 characters" },
      // {
      //   pattern:
      //     "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$",
      //   message:
      //     "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character",
      // },
    ],
  },
]

export const enquiryFormControls = [
  {
    name: 'name',
    label: 'Full Name',
    placeholder: '',
    type: 'text',
    componentType: 'input',
    className:
      'border-0 border-b focus:outline-none focus:ring-0 shadow-none focus:shadow-none border-b-input-border-color px-3 py-4 rounded-none pl-0 mb-3 text-gray-800',
    validations: [{ required: true, message: 'Name is required' }],
  },
  {
    name: 'email',
    label: 'Email',
    placeholder: '',
    type: 'email',
    componentType: 'input',
    className:
      'border-0 border-b focus:outline-none focus:ring-0 shadow-none focus:shadow-none border-b-input-border-color px-3 py-4 rounded-none pl-0 mb-3 text-gray-800',
    validations: [
      { required: true, message: 'Email is required' },
      {
        pattern: '^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$',
        message: 'Please enter a valid email address',
      },
    ],
  },
  {
    name: 'phone',
    label: 'Phone Number',
    placeholder: '',
    type: 'number',
    componentType: 'input',
    className:
      'border-0 border-b focus:outline-none focus:ring-0 shadow-none focus:shadow-none border-b-input-border-color px-3 py-4 rounded-none pl-0 mb-3 appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield] text-gray-800',
    validations: [
      { required: true, message: 'Phone number is required' },
      {
        pattern: '^[0-9]+$',
        message: 'Please enter numbers only',
      },
    ],
  },
  {
    name: 'message',
    label: 'Message',
    placeholder: '',
    type: 'text',
    componentType: 'input',
    className:
      'border-0 border-b focus:outline-none focus:ring-0 shadow-none focus:shadow-none border-b-input-border-color px-3 py-4 rounded-none pl-0 mb-3 text-gray-800',
    validations: [{ required: true, message: 'Message is required' }],
  },
]

export const forgotPasswordFormControl = [
  {
    name: 'email',
    label: 'Email',
    placeholder: 'Enter your email',
    type: 'email',
    componentType: 'input',
    className: 'border border-input-border-color px-3 py-6 rounded-sm text-gray-800',
    validations: [
      { required: true, message: 'Email is required' },
      {
        pattern: '^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$',
        message: 'Please enter a valid email address',
      },
    ],
  },
]

// ==========================================================================================================================================
// ======================================================[ initial value ]===================================================================
// ==========================================================================================================================================

export const initialUserSignUpFormData = {
  name: '',
  email: '',
  country_code: 'AE +971',
  mobile: '',
  address: '',
  city: '',
  state: '',
  postal_code: '',
  country: 'united_arab_emirates',
  gender: '',
  dob: '',
  acceptTerms: false,
}

export const initialBussinessSignUpFormData = {
  business_name: '',
  email: '',
  address: '',
  business_type: '',
  country_code: 'AE +971',
  mobile: '',
  // bankAccountNumber: '',
  // bankName: '',
  // ifscCode: '',
  acceptTerms: false,
}

export const initialUserSignInFormData = {
  country_code: 'AE +971',
  mobile: '',
}

export const initialBussinessSignInFormData = {
  email: '',
  password: '',
}

export const initialEnquiryFormData = {
  name: '',
  email: '',
  mobile: '',
  message: '',
}

export const initialForgotPasswordFormdata = {
  email: '',
}
